import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { InputField, SelectFieldStatus } from "../../../components/Form/FormComponents";
import { getFormattedDate } from "../../../utils/DateUtils";
import { StyledForm } from "../../../components/Form/FormComponents.styled";

const SavingsForm = ({ leaseData }) => {
	// eslint-disable-next-line no-unused-vars
	const [formData, setFormData] = useState(leaseData);

	return (
		<StyledForm>
			<div className='RightSection w-full'>
				<FormAccordion title='Savings Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<label>DATE / TIME</label>
							<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
						</div>

						<div className='form-group'>
							<label>SAVINGS TYPE</label>
							<InputField name='savingsType' value={formData?.savingsType} />
						</div>

						<div className='form-group'>
							<label>ASSET NAME</label>
							<InputField name='productName' value={formData?.productName} />
						</div>

						<div className='form-group'>
							<label>FREQUENCY</label>
							<InputField name='frequency' value={formData?.frequency} />
						</div>

						<div className='form-group'>
							<label>DAY OF MONTH</label>
							<InputField name='dayOfTheMonth' value={formData?.dayOfTheMonth} />
						</div>

						<div className='form-group'>
							<label>TENOR</label>
							<InputField name='tenure' value={formData?.tenure} />
						</div>

						<div className='form-group'>
							<label>AMOUNT</label>
							<InputField name='amountToSave' value={formData?.amountToSave} />
						</div>

						<div className='form-group'>
							<label>INTEREST</label>
							<InputField name='interestRate' value={formData?.interestRate} />
						</div>

						<div className='form-group'>
							<label>AUTOMATION</label>
							<InputField name='automation' value={formData?.automation} />
						</div>

						<div className='form-group'>
							<label>PAYMENT MODE</label>
							<InputField name='paymentMode' value={formData?.paymentMode} />
						</div>

						<div className='form-group'>
							<label>WITHDRAWAL REQUEST</label>
							<InputField name='maturityDate' value={formData?.maturityDate} />
						</div>

						<div className='form-group'>
							<label>STATUS</label>
							<SelectFieldStatus name='status' value={formData?.status} type='pending' />
						</div>

						{/* <div className='form-group'>
							<label>HISTORY</label>
							<a href='#' style={{ textDecoration: "underline" }}>
								View History
							</a>
						</div> */}
					</div>
				</FormAccordion>
			</div>
		</StyledForm>
	);
};

// Props Validation
SavingsForm.propTypes = {
	leaseData: PropTypes.object,
};

export default SavingsForm;
